import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import apiClient from "../common/http.service";

export const usePledges = (page = 1, limit = 10) => {
    const queryClient = useQueryClient();

    const pledgeQuery = useQuery({
        queryKey: ["pledges", page, limit], 
        queryFn: async () => {
            const response = await apiClient.get(`/pledge?page=${page}&limit=${limit}`);
            return response?.data || {}; 
        },
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
    });

    const createMutation = useMutation({
        mutationFn: (data) => apiClient.post("/pledge", data),
        onSuccess: () => {
            toast.success("Pledge created successfully");
            queryClient.invalidateQueries({ queryKey: ["pledges"] });
        },
        onError: (err) =>
            toast.error(err.response?.data?.message || "Create failed"),
    });

    const updateMutation = useMutation({
        mutationFn: ({ id, data }) => apiClient.put(`/pledge/${id}`, data),
        onSuccess: () => {
            toast.success("Pledge updated successfully");
            queryClient.invalidateQueries({ queryKey: ["pledges"] });
        },
        onError: (err) =>
            toast.error(err.response?.data?.message || "Update failed"),
    });

    const deleteMutation = useMutation({
        mutationFn: (id) => apiClient.delete(`/pledge/${id}`),
        onSuccess: () => {
            toast.success("Pledge deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["pledges"] });
        },
        onError: (err) =>
            toast.error(err.response?.data?.message || "Delete failed"),
    });

    return {
        pledges: Array.isArray(pledgeQuery.data?.data) ? pledgeQuery.data.data : [],
        pagination: pledgeQuery.data?.pagination || null, 

        isLoading: pledgeQuery.isLoading,
        isError: pledgeQuery.isError,
        error: pledgeQuery.error,

        createPledge: createMutation.mutateAsync,
        isCreating: createMutation.isPending,

        updatePledge: updateMutation.mutateAsync,
        isUpdating: updateMutation.isPending,

        deletePledge: deleteMutation.mutateAsync,
        isDeleting: deleteMutation.isPending,
    };
};